import { SVGProps, Ref, forwardRef } from 'react';

export const AUSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M21.333 3H2.667q-.206 0-.403.031l-.003 1.214-1.82-.002A2.84 2.84 0 0 0 0 5.769v12.462C0 19.76 1.194 21 2.667 21h18.666C22.806 21 24 19.76 24 18.23V5.77C24 4.24 22.806 3 21.333 3"
            fill="#00247D"
        />
        <path
            d="m6 17.554-.815.782.081-1.15-1.097-.173.916-.65-.553-1 1.06.338L6 14.63l.408 1.072 1.06-.338-.553 1 .916.65-1.096.174.08 1.149zM18.633 6.158l-.532.511.052-.752-.718-.113.6-.426-.362-.653.694.22.266-.7.268.7.694-.22-.362.653.598.426-.717.113.053.752zm-2.666 4.154-.533.512.053-.752-.718-.114.599-.426-.361-.654.693.221.267-.701.267.701.694-.22-.362.653.599.426-.718.114.053.752zm6-1.384-.533.511.053-.752-.718-.113.599-.427-.361-.653.693.22.267-.7.267.7.694-.22-.362.653.599.427-.718.113.053.752zm-3.334 9.692-.532.511.052-.751-.718-.114.6-.426-.362-.654.694.22.266-.7.268.7.694-.22-.362.654.598.426-.717.114.053.752zm2.034-8.005.196.413.438.066-.317.32.075.454-.392-.214-.392.214.074-.454-.316-.32.438-.066z"
            fill="white"
        />
        <path
            d="M12.667 12V3h-10c-.214 0-.403.031-.403.031l-.003 1.214-1.82-.002s-.028.04-.084.142C.13 4.792 0 5.265 0 5.769V12z"
            fill="#00247D"
        />
        <path
            d="M12.667 3h-1.554L8 5.263V3H4.667v1.779L2.264 3.03c-.41.065-.793.225-1.115.46L4.284 5.77H3.127L.645 3.963q-.11.133-.204.28l2.101 1.526H0v3.462h2.59L0 11.146V12h2.221l2.446-1.778V12H8V9.737L11.112 12h1.555v-1.405L10.79 9.231h1.877V5.769H10.79l1.876-1.364z"
            fill="#EEEEEE"
        />
        <path d="M7.333 3h-2v3.462H0v2.076h5.333V12h2V8.538h5.334V6.462H7.333z" fill="#CF1B2B" />
        <path
            d="M12.667 3h-.974L8 5.685v.084h1.047l3.62-2.632zm-11.518.492a2.7 2.7 0 0 0-.504.471l2.482 1.806h1.156zM4.291 9.23.49 12h1.152l3.026-2.2v-.57zm8.376 2.632v-.845l-2.458-1.787H9.047z"
            fill="#CF1B2B"
        />
    </svg>
));
AUSize24Glyph.displayName = 'AUSize24Glyph';
